import { render, staticRenderFns } from "./uom.vue?vue&type=template&id=486dd0c8&scoped=true&lang=pug"
import script from "./uom.vue?vue&type=script&lang=js"
export * from "./uom.vue?vue&type=script&lang=js"
import style0 from "./uom.vue?vue&type=style&index=0&id=486dd0c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486dd0c8",
  null
  
)

export default component.exports